import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent, Typography, Grid, Box, Button, Modal } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import SubscriptionChart from "../components/SubscriptionChart";
import LoadingIndicator from "../components/LoadingIndicator";

// Register required Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const AdminDashboard = () => {
    const [analytics, setAnalytics] = useState(null);
    const [selectedReseller, setSelectedReseller] = useState(null);
    const [topResellers, setTopResellers] = useState([])

    // Sort resellers by revenue and get the top 10

    const handleResellerClick = (reseller) => {
        setSelectedReseller(reseller);
    };

    const handleCloseModal = () => {
        setSelectedReseller(null);
    };

    useEffect(() => {
        axios
            .get("http://localhost:5000/api/analytics", { withCredentials: true })
            .then((response) => {
                console.log("✅ Analytics Data:", response.data);
                setAnalytics(response.data);

                const topResellers = [...response.data.resellerRevenue]
                    .sort((a, b) => b.totalRevenue - a.totalRevenue)
                    .slice(0, 10);
                setTopResellers(topResellers)
            })
            .catch((error) => console.error("❌ Error fetching analytics:", error));
    }, []);

    if (!analytics) {
        return <LoadingIndicator message="Fetching analytics data..." />;
    }

    // 📊 Subscription Chart Data
    const subscriptionChartData = {
        labels: analytics.subscriptionsByPlan.map((plan) => plan._id || "No Plan"),
        datasets: [
            {
                label: "Subscriptions",
                data: analytics.subscriptionsByPlan.map((plan) => plan.count),
                backgroundColor: ["#4caf50", "#ff9800", "#f44336", "#2196f3", "#9c27b0"],
            },
        ],
    };

    return (
        <Box
            sx={{
                padding: 4,
                backgroundColor: "#f5f5f5",
                minHeight: "100vh",
            }}
        >
            <Typography variant="h4" gutterBottom>
                Admin Dashboard
            </Typography>

            {/* Stats Cards */}
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ backgroundColor: "#4caf50", color: "#fff" }}>
                        <CardContent>
                            <Typography variant="h6">Active Users</Typography>
                            <Typography variant="h3">{analytics.activeUsers}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ backgroundColor: "#f44336", color: "#fff" }}>
                        <CardContent>
                            <Typography variant="h6">Inactive Users</Typography>
                            <Typography variant="h3">{analytics.inactiveUsers}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Card sx={{ backgroundColor: "#ff9800", color: "#fff" }}>
                        <CardContent>
                            <Typography variant="h6">Total Revenue</Typography>
                            <Typography variant="h3">
                                ${analytics.totalRevenue.toLocaleString()}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* Subscriptions Chart */}
            {/* <Box sx={{ marginTop: 4 }}>
        <Typography variant="h5" gutterBottom>
          Subscriptions Breakdown
        </Typography>
        <Card sx={{ padding: 2 }}>
          <Bar data={subscriptionChartData} />
        </Card>
      </Box> */}

            <div>
                <h2>Subscriptions Breakdown</h2>
                <SubscriptionChart data={analytics.subscriptionsByPlan} />
            </div>

            {/* Reseller Revenue */}
            {/* <Box sx={{ marginTop: 4 }}>
                <Typography variant="h5" gutterBottom>
                    Reseller Revenue Breakdown
                </Typography>
                <Grid container spacing={1}>
                    {analytics.resellerRevenue.map((reseller, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card sx={{ backgroundColor: "#2196f3", color: "#fff" }}>
                                <CardContent>
                                    <Typography variant="h6">Reseller: {reseller.name}</Typography>
                                    <Typography variant="body1">{reseller.email}</Typography>
                                    <Typography variant="h5" sx={{ marginTop: 1 }}>
                                        💰 ${reseller.totalRevenue.toLocaleString()}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box> */}

            <Box sx={{ marginTop: 4 }}>
                <Typography variant="h5" gutterBottom>
                    Reseller Revenue Breakdown (Top 10)
                </Typography>
                <Grid container spacing={2}>
                    {topResellers.map((reseller, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Card
                                sx={{
                                    backgroundColor: "#2196f3",
                                    color: "#fff",
                                    cursor: "pointer",
                                }}
                                onClick={() => handleResellerClick(reseller)}
                            >
                                <CardContent>
                                    <Typography variant="h6">Reseller: {reseller.name || "Unknown"}</Typography>
                                    <Typography variant="body1">{reseller.email}</Typography>
                                    <Typography variant="h5" sx={{ marginTop: 1 }}>
                                        💰 ${reseller.totalRevenue.toLocaleString()}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                {/* Reseller Details Modal */}
                <Modal
                    open={!!selectedReseller}
                    onClose={handleCloseModal}
                    sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                >
                    <Box
                        sx={{
                            width: "90%",
                            maxWidth: 600,
                            backgroundColor: "#fff",
                            padding: 4,
                            borderRadius: 2,
                            boxShadow: 24,
                        }}
                    >
                        {selectedReseller && (
                            <>
                                <Typography variant="h6" gutterBottom>
                                    Reseller Details
                                </Typography>
                                <Typography variant="body1">
                                    <strong>ID:</strong> {selectedReseller._id}
                                </Typography>
                                <Typography variant="body1">
                                    <strong>Name:</strong> {selectedReseller.name}
                                </Typography>
                                <Typography variant="body1">
                                    <strong>Email:</strong> {selectedReseller.email}
                                </Typography>
                                <Typography variant="body1">
                                    <strong>Credits:</strong> {selectedReseller.credits}
                                </Typography>
                                <Typography variant="body1">
                                    <strong>Clients:</strong> {selectedReseller.clientCount}
                                </Typography>
                                <Typography variant="body1">
                                    <strong>Total Revenue:</strong> ${selectedReseller.totalRevenue.toLocaleString()}
                                </Typography>

                                <Typography variant="h6" sx={{ marginTop: 2 }}>
                                    Transaction History
                                </Typography>
                                {selectedReseller.transactionHistory.length > 0 ? (
                                    <Box
                                        sx={{
                                            maxHeight: 300,
                                            overflowY: "auto",
                                            marginTop: 1,
                                        }}
                                    >
                                        {selectedReseller.transactionHistory.map((transaction) => (
                                            <Box
                                                key={transaction._id}
                                                sx={{
                                                    borderBottom: "1px solid #ddd",
                                                    paddingBottom: 1,
                                                    marginBottom: 1,
                                                }}
                                            >
                                                <Typography variant="body2">
                                                    <strong>Date:</strong> {new Date(transaction.date).toLocaleString()}
                                                </Typography>
                                                <Typography variant="body2">
                                                    <strong>Balance:</strong> {transaction.balance}
                                                </Typography>
                                                <Typography variant="body2">
                                                    <strong>Type:</strong> {transaction.balanceType}
                                                </Typography>
                                                <Typography variant="body2">
                                                    <strong>Comment:</strong> {transaction.comment}
                                                </Typography>
                                                <Typography variant="body2">
                                                    <strong>Order ID:</strong> {transaction.orderId}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                ) : (
                                    <Typography>No transactions available.</Typography>
                                )}

                                <Button
                                    variant="contained"
                                    onClick={handleCloseModal}
                                    sx={{ marginTop: 2 }}
                                >
                                    Close
                                </Button>
                            </>
                        )}
                    </Box>
                </Modal>
            </Box>
        </Box>
    );
};

export default AdminDashboard;
